var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentMethodComponent,{tag:"component",attrs:{"method":_vm.method,"instructions-data":_vm.instructionsData,"can-cancel":_vm.canCancel},on:{"completed":_vm.handleCompleted,"cancel":_vm.handleCancel,"title-change":_vm.titleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }